var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioOff = function SvgAudioOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99 9.017zv13.966h4.63l6.983 6.983V20.63M28.487 22.819c.04-.074.08-.154.136-.271.112-.235.313-.66.486-1.082a13.864 13.864 0 0 0 .915-3.287c.102-.687.158-1.432.169-2.044s-.023-1.092-.08-1.595-.133-1.029-.262-1.638a13 13 0 0 0-.617-2.086 18 18 0 0 0-1.136-2.322 12 12 0 0 0-1.081-1.542 14 14 0 0 0-1.203-1.315c-.501-.481-1.151-1.04-1.83-1.513s-1.39-.864-1.918-1.127c-.528-.264-.875-.401-1.167-.509s-.53-.186-.767-.264M20.116 10.761c.149.13.299.262.409.364s.18.177.248.248h0c.068.072.133.14.244.266a5.9 5.9 0 0 1 .973 1.49c.17.365.319.778.419 1.156s.15.72.18 1.001.041.498.039.78a7 7 0 0 1-.056.846M11.15 5.486l3.453-3.453v6.906M22.671 28.698l-.324.17a17 17 0 0 1-.836.396c-.13.057-.247.106-.394.165s-.326.13-.495.196-.33.126-.49.186h0M1.855 1.987l28.388 28.388"
  })));
};
export default SvgAudioOff;